module.exports = __webpack_public_path__ + "officialStatic/img/olt-detailList11.67e9f66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/olt-detailList11.png
// module id = xLh5
// module chunks = 0